export default __webpack_public_path__ + "static/media/edit.b5c2e472.svg";